import { Select } from "antd";
import { useMemo } from "react";
import { ExtendedFilterDropdownProps } from "./models";
import styles from "./TableDropdown.module.scss";
import { TableDropdownFooter } from "./TableDropdownFooter";
import clsx from "clsx";

export type SelectMode = "multiple" | "tags";

type SelectTableDropdownProps = ExtendedFilterDropdownProps & {
  selectMode?: SelectMode;
  isFilterOption?: boolean;
};

const filterOptionsLabelFromBeginning = (
  inputValue: string,
  option: any | undefined
) => {
  return inputValue && option
    ? option?.label.toUpperCase().startsWith(inputValue.toUpperCase())
    : true;
};

export const SelectTableDropdown = (props: SelectTableDropdownProps) => {
  const {
    setSelectedKeys,
    selectedKeys,
    filters,
    loading,
    selectMode,
    isFilterOption = true,
  } = props;

  const options = useMemo(
    () =>
      filters?.map((filter) => ({
        label: filter.text,
        value: filter.value,
      })),
    [filters]
  );

  return (
    <div>
      <div
        className={clsx(styles.inputContainer, {
          [styles.multiSelectContainer]: selectMode === "multiple",
        })}
      >
        <Select
          value={selectedKeys[0]}
          onChange={(value) => {
            setSelectedKeys(value ? [value] : []);
          }}
          loading={loading}
          options={options}
          className={styles.input}
          mode={selectMode}
          showSearch
          optionFilterProp="label"
          filterOption={
            isFilterOption ? filterOptionsLabelFromBeginning : undefined
          }
        />
      </div>
      <TableDropdownFooter {...props} />
    </div>
  );
};
